const singles = [
  {
    id: 1,
    artist_id: 1,
    search_count: 100,
    streams_count: 123456,
    type: "Single",
    audio_src: "https://utfs.io/f/YPK6Os4Irq6Ty582MLj2W98eN4mHz0VkPwXo5iEUbvtl7MBa",
    genre: "hip hop",
    title: "COLTELLINO (feat. Baby Gang)",
    artist: "Elgrandetoto",
    cover_art: "https://i.scdn.co/image/ab67616d00001e026bfe73b03ea4f80afa0e9571",
    duration: "03:06",
  },
  {
    id: 2,
    search_count: 100,
    artist_id: 1,
    title: "“DELLALI” feat. ​⁠Hamza",
    genre: "hip hop",
    streams_count: 123456,
    type: "Single",
    audio_src: "https://utfs.io/f/YPK6Os4Irq6TOgo1OBpcXgBPxNqspjoDwHT2b6S9Uv7YtnAf",
    artist: "Elgrandetoto",
    cover_art: "https://i.scdn.co/image/ab67616d0000b2736e4a689465371b26f5787407",
    duration: "04:48",
  },
  {
    id: 3,
    genre: "hip hop",
    streams_count: 123456,
    search_count: 100,
    artist_id: 1,
    title: "DIPLOMATICO",
    artist: "Elgrandetoto",
    audio_src: "https://utfs.io/f/YPK6Os4Irq6TiWIBoxaKtGu2HpP7DF9rJR6MBQWf81j4Nml5",
    cover_art: "https://i.scdn.co/image/ab67616d00001e026d0f919e5752da1968400eb6",
    duration: "03:26",
    type: "Single",
  },
  {
    id: 4,
    genre: "pop",
    streams_count: 123456,
    search_count: 100,
    artist_id: 2,
    title: "Unstoppable",
    artist: "Sia",
    audio_src: "https://utfs.io/f/YPK6Os4Irq6Tykl4dlj2W98eN4mHz0VkPwXo5iEUbvtl7MBa",
    cover_art: "https://i.scdn.co/image/ab67616d00001e0249e0134c686547c28b7c999f",
    duration: "03:46",
    type: "Single",
  },
  {
    id: 5,
    genre: "pop",
    streams_count: 123456,
    search_count: 100,
    artist_id: 2,
    title: "Snowman",
    artist: "Sia",
    audio_src: "https://utfs.io/f/YPK6Os4Irq6TMHvbmTHodXaksruV85ON7bR6wBGeSJCqgjmx",
    cover_art: "https://i.scdn.co/image/ab67616d00001e02d1410c1372fab1e516328fa8",
    duration: "02:48",
    type: "Single",
  },
  {
    id: 6,
    genre: "hip hop",
    streams_count: 123456,
    search_count: 100,
    artist_id: 3,
    title: "Like That",
    artist: "Metro Boomin",
    audio_src: "https://utfs.io/f/YPK6Os4Irq6T8QMUXfvUwcuthBLpYIA2XydS7oaMCqRgKFbl",
    cover_art: "https://i.scdn.co/image/ab67616d00001e02a46b07c291e6dfdee13b3ee8",
    duration: "04:29",
    type: "Single",
  },
  {
    id: 7,
    genre: "hip hop",
    streams_count: 123456,
    search_count: 100,
    artist_id: 3,
    title: "Type Shit",
    artist: "Metro Boomin",
    audio_src: "https://utfs.io/f/YPK6Os4Irq6TSe3B80lbvtxh8qzOlJae0UTorwcVk6Cm4py5",
    cover_art: "https://i.scdn.co/image/ab67616d00001e02a46b07c291e6dfdee13b3ee8",
    duration: "03:49",
    type: "Single",
  },
  {
    id: 8,
    genre: "hip hop",
    streams_count: 123456,
    search_count: 100,
    artist_id: 4,
    title: "20 Min",
    artist: "Lil Uzi Vert",
    audio_src: "https://utfs.io/f/YPK6Os4Irq6ToATPLoDh4O3jSi95J0zbFPdRUvqgZG7Qucxy",
    cover_art: "https://i.scdn.co/image/ab67616d00001e02d5f96a807d04f42d0055d0f7",
    duration: "03:41",
    type: "Single",
  },
  {
    id: 9,
    genre: "hip hop",
    streams_count: 123456,
    search_count: 100,
    artist_id: 4,
    title: "XO Tour Llif3",
    artist: "Lil Uzi Vert",
    audio_src: "https://utfs.io/f/YPK6Os4Irq6TdugkMESOq1XPEw67U4YT8Qpnb5axWZeKNgAR",
    cover_art: "https://i.scdn.co/image/ab67616d00001e02d5f96a807d04f42d0055d0f7",
    duration: "04:16",
    type: "Single",
  },
];

const getSingleById = (id) => singles.find((single) => single.id === id) || null;

const getSinglesByArtistId = (id) => {
  const singlesByArtist = singles.filter((single) => single.artist_id === id);
  if (singlesByArtist.length === 0) {
    throw new Error(`No singles found for artist with ID ${id}.`);
  }
  return singlesByArtist;
};

const getPopularSinglesByGenre = (genre) => {
  const searchGenre = genre.split('-').join(' ');
  return singles
    .filter((single) => single.genre === searchGenre)
    .sort((a, b) => b.streams_count - a.streams_count)
    .slice(0, 10);
};

const getPopularSinglesByStreams = () => {
  return singles
    .sort((a, b) => b.streams_count - a.streams_count)
    .slice(0, 12);
};

const getPopularSinglesBySearchCount = () => {
  return singles
    .sort((a, b) => b.search_count - a.search_count)
    .slice(0, 12);
};

const searchSinglesByValue = (value, limit = 12) => {
  return singles
    .filter((item) => item.title.includes(value.toLowerCase()))
    .sort((a, b) => (b.streams || 0) - (a.streams || 0))
    .slice(0, limit);
};

const getRelatedSingles = (singleId) => {
  const currentSingle = singles.find((single) => single.id === singleId);
  if (!currentSingle) return [];
  return singles.filter((single) => single.artist_id === currentSingle.artist_id && single.id !== singleId);
};

export { getSingleById, getSinglesByArtistId, getPopularSinglesByGenre, getPopularSinglesByStreams, getPopularSinglesBySearchCount, searchSinglesByValue, getRelatedSingles };